import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined';
import ProgressBar from './ProgressBar';
import Modal_Loading from './Modal_Loading'
/* Button */
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import schools from '../data/schools.json'
import districts from '../data/districts.json'

import ColumnStatus from './ColumnStatus'

import ContentContext from './ContentContext'
import { useDispatch, useSelector } from 'react-redux'
import {backToInitialValuesUpdated} from '../redux/slices/translationSlice'
import {backToInitialValuesUpdated_int} from '../redux/slices/interpretationSlice'
import {backToInitialValuesUpdated_bil} from '../redux/slices/assessmentSlice'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomizedSnackbars from './CustomizedSnackbars';

import SignatureUpload from './SignatureUpload'

import axios from 'axios'

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import { SchoolOutlined } from '@material-ui/icons';

const ApprovalContent_Interpretations = ({ handleProgressBarChange, handleContinueButton }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  const [canProceed, setCanProceed] = useState(false);
  const [column1Complete, setColumn1Complete] = useState(true)
  const [docToInterperateFiles_int, setDocToInterperateFiles_int] = useState([])
  // Files fields
  const [intakeFile, setIntakeFile] = useState('')
  const [signatureFile, setSignatureFile] = useState('')
  // These are for the loading snack
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [loadingSnack, setLoadingSnack] = useState(false);
  const [loadingSnackClass, setLoadingSnackClass] = useState("success");

  const dispatch = useDispatch();
  const translationState = useSelector((state) => state.translation);
  const interpretationState = useSelector((state) => state.interpretation);
  const assessmentState = useSelector((state) => state.assessment);

  const dataForQB = useTranslation()
  const setDataForQB = useTranslationUpdate()
  var jsonPOSTdata = null;
  var ridDOdata = {
    "from": "bq7w5k4s2",
    "select": [
      3
    ],
    "where": "{3.GT.'0'}",
    "sortBy": [
      {
        "fieldId": 3,
        "order": "DESC"
      }
    ],
    "groupBy": [
      {
        "fieldId": 3,
        "grouping": "equal-values"
      }
    ],
    "options": {
      "skip": 0,
      "top": 0,
      "compareWithAppLocalTime": false
    }
  }
  var interTestingPOSTdata = null;
  var testPostData = null;
  var districtId = 0;
  var schoolId = 0;
  var studentDistrictId = 0;
  var NEW_RID;

  function getJsonValueByName(jsonData, name){
    let valToReturn = "0";
    let l = Object.keys(jsonData).length;
    for (var i = 0; i < l; i++) {
      
      if (name == jsonData[i].name)
      {
        valToReturn = jsonData[i].id//.toString();
        //console.log("FOUND " + name + " = " + jsonData[i].id)
        break;
      }
      //else console.log(name + " NO MATCH " + jsonData[i].name)
    }
    return valToReturn
  }

  async function finalizeJSONAndCallAPS() {
    // Convert strings to their QB rids
    districtId = getJsonValueByName(districts, interpretationState.districtDropdown_int)
    schoolId = getJsonValueByName(schools, interpretationState.schoolDropdown_int)
    studentDistrictId = getJsonValueByName(districts, interpretationState.studentDistrictDropdown_int)

    dataForQB.approverSignatureFile_int = "";
    //console.log(intakeFile)
    var st = intakeFile.indexOf("/");
    var en = intakeFile.indexOf(";")
    var intakeFileExt = intakeFile.substring(st+1, en)
    //console.log("START: " + st + " END: " + en)
    var startIndex = intakeFile.indexOf(";base64,");
    var finalIntakeFile = intakeFile.substring(startIndex+8, intakeFile.length)
    //console.log("INTAKE FILEEEEEEE\n"+finalIntakeFile)
    
    setIntakeFile(finalIntakeFile);
    //setIntakeFile(btoa('iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='))
    
    jsonPOSTdata = {
      "to": "bq7w5k4s2",
      "data": [
        {
          "7": { "value": interpretationState.dueDate_int },
          "8": { "value": interpretationState.interpretationTypes_int },
          "227": { "value": interpretationState.testingSubject_int },
          "9": { "value": interpretationState.estimatedDurationHrs_int },
          "10": { "value": interpretationState.estimatedDurationMins_int },
          "11": { "value": interpretationState.paperWorkChecked_int },
          "12": { "value": interpretationState.needInterpreterChecked_int },
          "13": { "value": interpretationState.onlineOrVirtChecked_int },
          "14": { "value": interpretationState.onlineMeetingLink_int },
          "15": { "value": interpretationState.studentName_int },
          "16": { "value": interpretationState.phone_int },
          "17": { "value": interpretationState.grade_int },
          "18": { "value": interpretationState.gender_int },
          "19": { "value": interpretationState.languageDropdown_int },
          "97": { "value": interpretationState.otherLanguages_int },
          "20": { "value": districtId },
          "25": { "value": schoolId },
          "27": { "value": interpretationState.address_int },
          "28": { "value": interpretationState.contactName_int },
          "29": { "value": interpretationState.contactPhone_int },
          "30": { "value": interpretationState.contactEmail_int },
          "31": { "value": interpretationState.approverName_int },
          "32": { "value": interpretationState.approverPosition_int },
          "33": { "value": interpretationState.approverEmail_int },
          "154": { "value": interpretationState.notes_int },
          "144": { "value": interpretationState.dueTime_int },
          "204": { "value": interpretationState.inPersonMeetingChecked_int },
          "207": { "value": interpretationState.teleconference_int },
          "208": { "value": interpretationState.teleconferencePhone_int },
          "231": { "value": interpretationState.coser_int },
          "244": { "value": studentDistrictId },
          "46": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "47": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "48": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "49": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "50": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "108": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "109": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "110": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "111": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          },
          "112": { "value": {
            "fileName": "empty.png",
            "data": ""
            }
          }
        }
      ],
      "fieldsToReturn": [
        3,
        4
      ]
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Add up to 10 file attachment fields

    // Get prefix for file attachment names
    let NEXT_RID_CALL = "";
    let NEXT_RID = 0;
    if (docToInterperateFiles_int.length >0) {
      
      NEXT_RID_CALL = await axios.post(
        'https://api.quickbase.com/v1/records/query',
        ridDOdata,
        {
          headers: {
            'QB-Realm-Hostname': 'nassauboces.quickbase.com',
            'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
          }
        }
      ).then((response) => {
        return response.data.data[0][3].value;
      }, (error) => {
        return "errorFetchingRID";
      });
      //alert(">"); 
      NEXT_RID = parseInt(NEXT_RID_CALL)+1;
    }
    let offset = 0;
    const currDate = new Date();
    if (currDate.getMonth()>5) offset = 1;
    const CURR_YR = (parseInt(new Date().getFullYear().toString().substring(2,4))+offset).toString();
    //CURR_YR = "23";
    const FILE_PREFIX = CURR_YR + "-" + NEXT_RID + "I-";

    // Doc 1 //
    if (docToInterperateFiles_int.length>0){
      var st = docToInterperateFiles_int[0].content.indexOf("/");
      var en = docToInterperateFiles_int[0].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[0].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[0].content.substring(startIndex+8, docToInterperateFiles_int[0].content.length)
      jsonPOSTdata.data[0][46].value.fileName = FILE_PREFIX + docToInterperateFiles_int[0].name;
      jsonPOSTdata.data[0][46].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][46];
    }

    // Doc 2 //
    if (docToInterperateFiles_int.length>1){
      var st = docToInterperateFiles_int[1].content.indexOf("/");
      var en = docToInterperateFiles_int[1].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[1].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[1].content.substring(startIndex+8, docToInterperateFiles_int[1].content.length)
      jsonPOSTdata.data[0][47].value.fileName = FILE_PREFIX + docToInterperateFiles_int[1].name;
      jsonPOSTdata.data[0][47].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][47];
    }

    // Doc 3 //
    if (docToInterperateFiles_int.length>2){
      var st = docToInterperateFiles_int[2].content.indexOf("/");
      var en = docToInterperateFiles_int[2].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[2].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[2].content.substring(startIndex+8, docToInterperateFiles_int[2].content.length)
      jsonPOSTdata.data[0][48].value.fileName = FILE_PREFIX + docToInterperateFiles_int[2].name;
      jsonPOSTdata.data[0][48].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][48];
    }

    // Doc 4 //
    if (docToInterperateFiles_int.length>3){
      var st = docToInterperateFiles_int[3].content.indexOf("/");
      var en = docToInterperateFiles_int[3].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[3].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[3].content.substring(startIndex+8, docToInterperateFiles_int[3].content.length)
      jsonPOSTdata.data[0][49].value.fileName = FILE_PREFIX + docToInterperateFiles_int[3].name;
      jsonPOSTdata.data[0][49].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][49];
    }

    // Doc 5 //
    if (docToInterperateFiles_int.length>4){
      var st = docToInterperateFiles_int[4].content.indexOf("/");
      var en = docToInterperateFiles_int[4].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[4].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[4].content.substring(startIndex+8, docToInterperateFiles_int[4].content.length)
      jsonPOSTdata.data[0][50].value.fileName = FILE_PREFIX + docToInterperateFiles_int[4].name;
      jsonPOSTdata.data[0][50].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][50];
    }

    // Doc 6 //
    if (docToInterperateFiles_int.length>5){
      var st = docToInterperateFiles_int[5].content.indexOf("/");
      var en = docToInterperateFiles_int[5].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[5].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[5].content.substring(startIndex+8, docToInterperateFiles_int[5].content.length)
      jsonPOSTdata.data[0][108].value.fileName = FILE_PREFIX + docToInterperateFiles_int[5].name;
      jsonPOSTdata.data[0][108].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][108];
    }

    // Doc 7 //
    if (docToInterperateFiles_int.length>6){
      var st = docToInterperateFiles_int[6].content.indexOf("/");
      var en = docToInterperateFiles_int[6].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[6].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[6].content.substring(startIndex+8, docToInterperateFiles_int[6].content.length)
      jsonPOSTdata.data[0][109].value.fileName = FILE_PREFIX + docToInterperateFiles_int[6].name;
      jsonPOSTdata.data[0][109].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][109];
    }

    // Doc 8 //
    if (docToInterperateFiles_int.length>7){
      var st = docToInterperateFiles_int[7].content.indexOf("/");
      var en = docToInterperateFiles_int[7].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[7].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[7].content.substring(startIndex+8, docToInterperateFiles_int[7].content.length)
      jsonPOSTdata.data[0][110].value.fileName = FILE_PREFIX + docToInterperateFiles_int[7].name;
      jsonPOSTdata.data[0][110].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][110];
    }

    // Doc 9 //
    if (docToInterperateFiles_int.length>8){
      var st = docToInterperateFiles_int[8].content.indexOf("/");
      var en = docToInterperateFiles_int[8].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[8].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[8].content.substring(startIndex+8, docToInterperateFiles_int[8].content.length)
      jsonPOSTdata.data[0][111].value.fileName = FILE_PREFIX + docToInterperateFiles_int[8].name;
      jsonPOSTdata.data[0][111].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][111];
    }

    // Doc 10 //
    if (docToInterperateFiles_int.length>9){
      var st = docToInterperateFiles_int[9].content.indexOf("/");
      var en = docToInterperateFiles_int[9].content.indexOf(";");
      var startIndex = docToInterperateFiles_int[9].content.indexOf(";base64,");
      let tempFile = docToInterperateFiles_int[9].content.substring(startIndex+8, docToInterperateFiles_int[9].content.length)
      jsonPOSTdata.data[0][112].value.fileName = FILE_PREFIX + docToInterperateFiles_int[9].name;
      jsonPOSTdata.data[0][112].value.data = tempFile;
    }
    else{
      delete jsonPOSTdata.data[0][112];
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Send the data
    getDataAxios();

  }

  const updateColumn1Count = (valueInInput) => {
    //alert("props.triggerUpdateFromParent/updateColumn1Count val: " + valueInInput)
    //setIntakeFile(valueInInput)
    setDocToInterperateFiles_int(valueInInput);
    dataForQB.docToInterperateFiles_int = valueInInput;
    //alert("INTAKE FILE AFTER SET: " + intakeFile)
    //if (valueInInput != "") setColumn1Complete(true)
    if (dataForQB.docToInterperateFiles_int.length > 0) setColumn1Complete(true)
    else setColumn1Complete(false)
    //alert("COL 1 COMPLETE AFTER SET: " + column1Complete)

    setColumn1Complete(true)
    setProgressBarDataInParent();
  }

  const setProgressBarDataInParent = () => {
    let temp = 0;
    //alert(intakeFile)
    // Col 1
    //if (dataForQB.docToInterperateFiles_int.length > 0) temp += 100;
    temp+=100
    //alert("SET PROGESS BAR DATA IN PARENT TEMP: " + temp)
    handleProgressBarChange(parseInt(temp))
  }

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  if (!dataForQB.intakeRunOnce){
    setTimeout(function(){
      dataForQB.intakeRunOnce = true;
      updateColumn1Count(dataForQB.docToInterperateFiles_int);
    },500)
    
  }

  function backToPreviousScreen(){
    dataForQB.intakeRunOnce = false
    handleThisContinueButton("main")
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      console.log(column1Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete]);


  const renderColumn1ColumnStatus = () => {
    return <ColumnStatus complete={column1Complete} />
  }
  //////////////////////////////////////////////////////////////

   function resetJSON(){
    dataForQB.translationTypes = [];
    dataForQB.iepText = '';
    dataForQB.iep_checked = '';
    dataForQB.transcriptText = '';
    dataForQB.transcript_checked = '';
    dataForQB.letterText = '';
    dataForQB.letter_checked = '';
    dataForQB.schoolDocumentText = '';
    dataForQB.schoolDocument_checked = '';
    dataForQB.calendarText = '';
    dataForQB.calendar_checked = '';
    dataForQB.flyerText = '';
    dataForQB.flyer_checked = '';
    dataForQB.handbookText = '';
    dataForQB.handbook_checked = '';
    dataForQB.healthFormsText = '';
    dataForQB.healthForms_checked = '';
    dataForQB.permissionSlipText = '';
    dataForQB.permissionSlip_checked = '';
    dataForQB.schedulesText = '';
    dataForQB.schedules_checked = '';
    dataForQB.evaluationsText = '';
    dataForQB.evaluations_checked = '';
    dataForQB.psychological_checked = '';
    dataForQB.educational_checked = '';
    dataForQB.socialHistory_checked = '';
    dataForQB.speechLanguage_checked = '';
    dataForQB.otherLanguageText = '';
    dataForQB.other_checked = '';
    dataForQB.otherText = '';
    dataForQB.dueDateText = '';
    dataForQB.districtDropdown = '';
    dataForQB.districtRid = 0;
    dataForQB.schoolDropdown = '';
    dataForQB.schoolRid = 0;
    dataForQB.languageDropdown = '';
    dataForQB.contactNameText = '';
    dataForQB.contactPhoneText = '';
    dataForQB.contactEmailText = '';
    dataForQB.approverNameText = '';
    dataForQB.approverPositionText = '';
    dataForQB.approverEmailText = '';
    dataForQB.intakeRunOnce = false;
    dataForQB.dueDate_int = '';
    dataForQB.dueTime_int = '';
    dataForQB.interpretationTypes_int = [];
    dataForQB.estimatedDurationHrs_int = '';
    dataForQB.estimatedDurationMins_int = '';
    dataForQB.paperWorkChecked_int = '';
    dataForQB.needInterpreterChecked_int = '';
    dataForQB.onlineOrVirtChecked_int = '';
    dataForQB.onlineMeetingLink_int = '';
    dataForQB.inPersonMeetingChecked_int = '';
    dataForQB.studentName_int = '';
    dataForQB.phone_int = '';
    dataForQB.grade_int = '';
    dataForQB.gender_int = '';
    dataForQB.languageDropdown_int = '';
    dataForQB.otherLanguages_int = '';
    dataForQB.districtDropdown_int = '';
    dataForQB.schoolDropdown_int = 0;
    dataForQB.address_int = '';
    dataForQB.contactName_int = '';
    dataForQB.contactPhone_int = '';
    dataForQB.contactEmail_int = '';
    dataForQB.approverName_int = '';
    dataForQB.approverPosition_int = '';
    dataForQB.approverEmail_int = '';
    dataForQB.districtRid_int = 0;
    dataForQB.schoolRid_int = 0;
    dataForQB.approverSignatureFile_int = '';
    dataForQB.tableData_int = [];
    dataForQB.assessmentRunOnce = false;
    dataForQB.studentFirstName_bil = '';
    dataForQB.studentLastName_bil = '';
    dataForQB.countryOfOrigin_bil = '';
    dataForQB.DOB_bil = '';
    dataForQB.gender_bil = '';
    dataForQB.yearsInUS_bil = '';
    dataForQB.grade_bil = '';
    dataForQB.childResidesWith_bil = '';
    dataForQB.mfg1_bil = '';
    dataForQB.mfgName1_bil = '';
    dataForQB.mfg2_bil = '';
    dataForQB.mfgName2_bil = '';
    dataForQB.childsResidesWithOther_bil = '';
    dataForQB.homeAddress_bil = '';
    dataForQB.homeNum_bil = '';
    dataForQB.workNum_bil = '';
    dataForQB.cellNum_bil = '';
    dataForQB.nativeLanguage_bil = '';
    dataForQB.nativeLanguageOther_bil = '';
    dataForQB.districtDropdown_bil = '';
    dataForQB.schoolDropdown_bil = '';
    dataForQB.CSEDate_bil = '';
    dataForQB.psychologistName_bil = '';
    dataForQB.psychologistEmail_bil = '';
    dataForQB.speechPathologistName_bil = '';
    dataForQB.speechPathologistEmail_bil = '';
    dataForQB.districtContactName_bil = '';
    dataForQB.districtContactTitle_bil = '';
    dataForQB.districtContactAddress_bil = '';
    dataForQB.districtContactPhone_bil = '';
    dataForQB.districtContactEmail_bil = '';
    dataForQB.reason_bil = '';
    dataForQB.alreadyClassified_bil = '';
    dataForQB.classification_bil = '';
    dataForQB.consentToEvalAttached_bill = false;
    dataForQB.priorWrittenNoticeAttached_bil = false;
    dataForQB.homeLangQuestAttached_bil = false;
    dataForQB.nonVerbSecDiagnosed_bil = false;
    dataForQB.studentEnterSchoolDate_bil = '';
    dataForQB.nameOfOtherSchoolAttended_bil = '';
    dataForQB.typesOfEvals_bil = [];
    dataForQB.diagnosedCondition_bil = '';
    dataForQB.diagnosedConditionText_bil = '';
    dataForQB.services_bil = [];
    dataForQB.generalHealth_bil = false;
    dataForQB.generalHealthText_bil = '';
    dataForQB.medication_bil = false;
    dataForQB.medicationText_bil = '';
    dataForQB.wearsGlasses_bil = false;
    dataForQB.wearsGlassesText_bil = '';
    dataForQB.pedRestrictions_bil = false;
    dataForQB.pedRestrictionsText_bil = '';
    dataForQB.physicalExamDate_bil = '';
    dataForQB.h_freq_audiology_bil = '';
    dataForQB.h_indv_audiology_bil = '';
    dataForQB.h_freq_visTherapy_bil = '';
    dataForQB.h_indv_visTherapy_bil = '';
    dataForQB.h_freq_resourceRoom_bil = '';
    dataForQB.h_indv_resourceRoom_bil = '';
    dataForQB.h_freq_counseling_bil = '';
    dataForQB.h_indv_counseling_bil = '';
    dataForQB.h_freq_speechLang_bil = '';
    dataForQB.h_indv_speechLang_bil = '';
    dataForQB.h_freq_physTherapy_bil = '';
    dataForQB.h_indv_physTherapy_bil = '';
    dataForQB.h_freq_occTherapy_bil = '';
    dataForQB.h_indv_occTherapy_bil = '';
    dataForQB.i_freq_Reading_bil = '';
    dataForQB.i_indv_Reading_bil = '';
    dataForQB.i_freq_AISMath_bil = '';
    dataForQB.i_indv_AISMath_bil = '';
    dataForQB.i_freq_AAtL_bil = '';
    dataForQB.i_indv_AAtL_bil = '';
    dataForQB.i_freq_AdjAssign_bil = '';
    dataForQB.i_indv_AdjAssign_bil = '';
    dataForQB.i_freq_schedAdj_bil = '';
    dataForQB.i_indv_schedAdj_bil = '';
    dataForQB.i_freq_indvProgBasedOnSkill_bil = '';
    dataForQB.i_indv_indvProgBasedOnSkill_bil = '';
    dataForQB.i_freq_speechImprov_bil = '';
    dataForQB.i_indv_speechImprov_bil = '';
    dataForQB.i_freq_tutoring_bil = '';
    dataForQB.i_indv_tutoring_bil = '';
    dataForQB.i_freq_consulServices_bil = '';
    dataForQB.i_indv_consulServices_bil = '';
    dataForQB.i_other_bil = '';
    dataForQB.areas_bil = [];
    dataForQB.addConcerns_bil = '';
    dataForQB.suspDetails_bil = '';
    dataForQB.docToTranslateFiles = [];
    dataForQB.docToInterperateFiles_int = [];
    dataForQB.docToAccessFiles_bil = [];
    dataForQB.consentToEvalAttachedFiles_bil = [];
    dataForQB.priorWrittenNoticeAttachedFiles_bil = [];
    dataForQB.homeLangQuestAttachedFiles_bil = [];
    dataForQB.notes_int = '';
    dataForQB.notes_bil = '';
    dataForQB.approverName_bil = '';
    dataForQB.approverTitle_bil = '';
    dataForQB.approverEmail_bil = '';
    dataForQB.teleconference_int = '';
    dataForQB.teleconferencePhone_int = '';
    dataForQB.currentTeacherName_bil = '';
    dataForQB.currentTeacherEmail_bil = '';

    dispatch(backToInitialValuesUpdated(translationState.backToInitialValues+1))
    dispatch(backToInitialValuesUpdated_int(interpretationState.backToInitialValues_int+1))
    dispatch(backToInitialValuesUpdated_bil(assessmentState.backToInitialValues_bil+1))
  }


  const progressBarData =
    { bgcolor: "#00695c", completed: 0 };

  const sendDatatoQB = () => {
    //alert("WTF")
    // First we'll set any checks based on if the field has data
    finalizeJSONAndCallAPS();    
  }

  async function getDataAxios() {
      // Show loading
      setShowLoadingModal(true)
      //alert("SET SHOW LOADING MODAL")
    // POST
    const response2 = await axios.post(
      'https://api.quickbase.com/v1/records',
      jsonPOSTdata,
      {
        headers: {
          'QB-Realm-Hostname': 'nassauboces.quickbase.com',
          'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
        }
      }
    )
    .then((response) => {

    /////////////////////////////////////////////////////////////
    // Testing
    /////////////////////////////////////////////////////////////
    console.log(response);
      // UP TO HERE, JUST NEED TO CONVERT THIS FROM dataForQB.students
      NEW_RID = response.data.data[0][3].value;
      var tempData = []
    
        // Loop through
        if (dataForQB.tableData_int.length > 0){
          for (var i = 0; i < dataForQB.tableData_int.length; i++)
          {
            if (dataForQB.tableData_int[i].nameOfStudent != ""){
              tempData.push({
                "6": { "value": dataForQB.tableData_int[i].nameOfStudent },
                "7": { "value": dataForQB.tableData_int[i].grade },
                "8": { "value": dataForQB.tableData_int[i].iep },
                "9": { "value": NEW_RID}
              })
            }
          }
        }

        if (tempData.length >0)
        {
          interTestingPOSTdata = {
            "to": "brtudcea2",
            "data": tempData,
            "fieldsToReturn": [
              3,
              4
            ]
          }
        
          // POST
          axios.post(
            'https://api.quickbase.com/v1/records',
            interTestingPOSTdata,
            {
              headers: {
                'QB-Realm-Hostname': 'nassauboces.quickbase.com',
                'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
              }
            }
          )
          .then((response) => {
            console.log(response)
            //setShowLoadingModal(false)
            setLoadingSnack("Your Interpretation has successfully processed!")
            setLoadingSnackClass("complete")
            console.log(response);
            // Show success for 3 seconds
            setTimeout(function () {
              resetJSON();
              setShowLoadingModal(false)
              setContentState('main')
    
            }, 4000)
          }, (error) => {
            setLoadingSnack("Sorry we are experiecing Technical Difficulties, try again later!")
            setLoadingSnackClass("error")
            // Show loading
            setShowLoadingModal(true)
            console.log("=========error===========")
            console.log(error);
            console.log("=========request===========")
            console.log(jsonPOSTdata)
            //alert("ERROR: " + error)
            // Show error for 3 seconds
            setTimeout(function () {
              resetJSON();
              setShowLoadingModal(false)
              setContentState('main')
            }, 5000)
          });
        }
        ///////////////////////////////////////////////////////////////
        else{
          setLoadingSnack("Your Interpretation has successfully processed!")
          setLoadingSnackClass("complete")
          console.log(response);
          // Show success for 3 seconds
          setTimeout(function () {
            resetJSON();
            setShowLoadingModal(false)
            setContentState('main')

          }, 4000)
        }
      
    /////////////////////////////////////////////////////////////

      
    }, (error) => {
      //setShowLoadingModal(false)
      setLoadingSnack("Sorry we are experiecing Technical Difficulties, try again later!")
      setLoadingSnackClass("error")
      // Show loading
      setShowLoadingModal(true)
      console.log("=========error===========")
      console.log(error);
      console.log("=========request===========")
      console.log(jsonPOSTdata)
      //alert("ERROR: " + error)
      // Show error for 3 seconds
      setTimeout(function () {
        setShowLoadingModal(false)
        setContentState('main')
      }, 5000)
    });
    
  }

  return (
    <div>
      {/*<FadeIn delay={200} duration={450}>*/}
      <Container fluid className="">
        <br/>
        <Box style={{width: '40%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
        <Card variant="outlined" style={{padding: '10px',}}>
          <CardContent>
        <Row>
          <Col>{renderColumn1ColumnStatus()}</Col>
        </Row>
        <Row>
          <Col>
            <h4 className="content-section-title">Interpretation File(s)</h4>
            <h4 className="content-section-title-sm">(Optional)</h4>
          </Col>
        </Row>
        <Row><Col><br /></Col></Row>
        <Row>
          <Col>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
              <FadeIn delay={150} duration={450}>
                {/* Signature Upload */}
                <SignatureUpload id="formFile" classesToAdd={""} maxFiles={2} valueInField={dataForQB.docToInterperateFiles_int} triggerUpdateFromParent={updateColumn1Count} required={true} />{/* Form Upload */}
              </FadeIn>
            </div>
          </Col>
        </Row>
        <Row><Col><br /></Col></Row>
        <Row><Col><br /></Col></Row>
      </CardContent>
      </Card>
      </Box>
      <Row>
            <Col>
            <div className='form-button-bottom-container' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', width: '40%' }}>
            <Button className="btn btn-primary form-button-bottom" onClick={sendDatatoQB} disabled={!column1Complete}
                variant="contained" color="primary">
                Submit Interpretation
              </Button>
              </div>
            </Col>
          </Row>
      </Container>

      <div className="form-button-bottom-container">
       {/*<Button className="btn btn-primary form-button-bottom" onClick={() => backToPreviousScreen()} disabled={false}//!column1Complete || !column2Complete}
          variant="contained" color="primary">
          Back
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;*/}
      </div>

      <Modal_Loading subClass={loadingSnackClass} text={loadingSnack} show={showLoadingModal} />
      {/*</FadeIn>*/}
    </div>
  )
}

export default ApprovalContent_Interpretations